<div class="help-center-page pd-24">
  <div class="help-center-shell card inverse-bg-transparent">
    <div class="help-center-grid">
      <section class="help-center-content" i18n-aria-label aria-label="Help center content">
        <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)" class="help-tabs">
          <p-tablist>
            <p-tab [value]="0">{{ 'HELP_CENTER.TABS.FAQ.TITLE' | translate }}</p-tab>
            <p-tab [value]="1">{{ 'HELP_CENTER.TABS.FILES.TITLE' | translate }}</p-tab>
            @if (isClientAdmin) {
              <p-tab [value]="2">{{ 'HELP_CENTER.TABS.USER_MANUAL.TITLE' | translate }}</p-tab>
              <p-tab [value]="3">{{ 'HELP_CENTER.TABS.API_REFERENCE.TITLE' | translate }}</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel [value]="0">
              <div class="scrollable-panel">
                <p-accordion>
                  @for (category of 'HELP_CENTER.TABS.FAQ.CATEGORIES' | translate | keyvalue; track category) {
                    <h2 class="faq-category">{{ category.value }}</h2>
                    @for (item of 'HELP_CENTER.TABS.FAQ.QUESTIONS.' + category.key | translate; track item) {
                      <p-accordionpanel [value]="item.QUESTION">
                        <p-accordionheader>{{ item.QUESTION }}</p-accordionheader>
                        <p-accordioncontent>
                          <p>{{ item.ANSWER }}</p>
                        </p-accordioncontent>
                      </p-accordionpanel>
                    }
                  }
                </p-accordion>
              </div>
            </p-tabpanel>
            <p-tabpanel [value]="1">
              <div class="files-panel">
                <ul class="file-list">
                  <li>
                    <a
                      href="https://storage.googleapis.com/yabi-papi-storage/files/support/passes_upload_templates/authorized_{{ translate.currentLang }}.xlsx"
                      target="_blank"
                      rel="noopener noreferrer"
                      >
                      <span class="file-title">{{ 'FILES.DOWNLOAD_TEMPLATE_FILE' | translate }} {{ 'SYSTEM.ENTITY_NAMES.AUTHORIZED' | translate }}</span>
                      <span class="file-action"><i class="pi pi-download" aria-hidden="true"></i></span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://storage.googleapis.com/yabi-papi-storage/files/support/passes_upload_templates/employees_{{ translate.currentLang }}.xlsx"
                      target="_blank"
                      rel="noopener noreferrer"
                      >
                      <span class="file-title">{{ 'FILES.DOWNLOAD_TEMPLATE_FILE' | translate }} {{ 'SYSTEM.ENTITY_NAMES.EMPLOYEES' | translate }}</span>
                      <span class="file-action"><i class="pi pi-download" aria-hidden="true"></i></span>
                    </a>
                  </li>
                </ul>
              </div>
            </p-tabpanel>
            <p-tabpanel [value]="2">
              <app-user-manual></app-user-manual>
            </p-tabpanel>
            @if (isClientAdmin) {
              <p-tabpanel [value]="3">
                <app-api-reference></app-api-reference>
              </p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      </section>

      <aside class="help-center-side">
        <app-interactive-guide class="guide-item">
          <h2>{{ randomTipTitle }}</h2>
          <p>{{ randomTipDescription }}</p>
        </app-interactive-guide>
      </aside>
    </div>
  </div>
</div>
